import selectCollection from "./collection"

export default function selectInvolved(state, engine, model, query) {
  const collection = selectCollection(state, engine, model, query)
  return collection ? collection.involved : false
}
